<template>
  <svg
    id="Group_48996"
    data-name="Group 48996"
    xmlns="http://www.w3.org/2000/svg"
    width="36.24"
    height="38.836"
    viewBox="0 0 36.24 38.836"
  >
    <rect
      id="Rectangle_18749"
      data-name="Rectangle 18749"
      width="36.24"
      height="38.836"
      rx="5"
      fill=""
    />
    <path
      id="Path_30300"
      data-name="Path 30300"
      d="M4.886,39.341v4.886H0v3.257H4.886v4.886H8.143V47.483h4.886V44.226H8.143V39.341Z"
      transform="translate(11.605 -26.437)"
      fill="#000"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
